import { captureException } from '@sentry/nextjs';

import { CalculatorInputData, FamilyQuoteData, PersonKey } from '../../model';

const FEATHER_BACKEND_URL = process.env.NEXT_PUBLIC_FEATHER_API_URL || '';

export const submitPrivatePreSignupQuestionnaire = async ({
  email,
  familyQuoteDataArray,
  calculatorInputArray,
  calculatorParams,
}: {
  email: string;
  familyQuoteDataArray: FamilyQuoteData[];
  calculatorInputArray: [PersonKey, CalculatorInputData][];
  calculatorParams?: string;
}) => {
  try {
    await fetch(`${FEATHER_BACKEND_URL}/questionnaires/`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        questionnaireType: 'PRIVATE_HEALTH_PRE_SIGNUP',
        answers: {
          email,
          familyQuoteData: familyQuoteDataArray,
          calculatorInput: calculatorInputArray,
          calculatorParams,
          sendEmail: true,
        },
        metadata: {},
      }),
    });
  } catch (error) {
    captureException(error);
  }
};
